var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99626 1.33301H3.99839C3.64489 1.33301 3.30587 1.47343 3.05591 1.72339C2.80595 1.97335 2.66553 2.31237 2.66553 2.66587V13.3287C2.66553 13.6822 2.80595 14.0213 3.05591 14.2712C3.30587 14.5212 3.64489 14.6616 3.99839 14.6616H11.9955C12.349 14.6616 12.6881 14.5212 12.938 14.2712C13.188 14.0213 13.3284 13.6822 13.3284 13.3287V4.66516L9.99626 1.33301Z",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33008 1.33301V3.99873C9.33008 4.35222 9.4705 4.69124 9.72046 4.9412C9.97042 5.19116 10.3094 5.33159 10.6629 5.33159H13.3287",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6644 5.99805H5.33154",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.663 8.66357H5.33154",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.663 11.3291H5.33154",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon29);
export default __webpack_public_path__ + "static/media/icon29.adcdd91a2d60553792a77c4f1b20ee5c.svg";
export { ForwardRef as ReactComponent };